import { Injectable } from '@angular/core';
import { ChartDataSets } from 'chart.js';
import { Label, SingleDataSet } from 'ng2-charts';

@Injectable({
  providedIn: 'root'
})
export class ReportingService {

  overviewLoadedAlmostOneTime: boolean = false;
  orderDetailLoadedAlmostOneTime: boolean = false;
  slaKpisLoadedAlmostOneTime: boolean = false;
  completedDetailLoadedAlmostOneTime: boolean = false;

  filtersOverviewChangedAlmostOneTime: boolean = false;
  filtersOrderDetailChangedAlmostOneTime: boolean = false;
  filtersSlaKpisChangedAlmostOneTime: boolean = false;
  fltersCompletedDetailChangedAlmostOneTime: boolean = false;

  selectedItemsOverview: any = {};
  selectedItemsOrderDetail: any = {};
  selectedItemsSlaKpis: any = {};
  selectedItemsCompletedDetail: any = {};

  listOrderDetail: any[] = [];
  pieChartLabelsOverview: Label[] = [];
  pieChartDataOverview: SingleDataSet = [];
  ordersOverview: any[] = [];
  listAverageSlaKpi: any[] = [];
  labelSlaKpi: Label[] = [];
  singleDataSetSlaKpi: SingleDataSet = [];
  chartDataCompleted: ChartDataSets[] = [];
  chartLabelsCompleted: Label[] = [];

  dropdownItemsOverview: any = {};
  dropdownItemsOrderDetail: any = {};
  dropdownItemsSlaKpis: any = {};
  dropdownItemsCompletedDetail: any = {};

  constructor() { }

  initReportingService() {

    this.overviewLoadedAlmostOneTime = false;
    this.orderDetailLoadedAlmostOneTime = false;
    this.slaKpisLoadedAlmostOneTime = false;
    this.completedDetailLoadedAlmostOneTime = false;
    this.filtersOverviewChangedAlmostOneTime = false;
    this.filtersOrderDetailChangedAlmostOneTime = false;
    this.filtersSlaKpisChangedAlmostOneTime = false;
    this.fltersCompletedDetailChangedAlmostOneTime = false;
    this.selectedItemsOverview= {};
    this.selectedItemsOrderDetail= {};
    this.selectedItemsSlaKpis= {};
    this.selectedItemsCompletedDetail= {};
    this.listOrderDetail = [];
    this.pieChartLabelsOverview = [];
    this.pieChartDataOverview = [];
    this.ordersOverview = [];
    this.listAverageSlaKpi = [];
    this.labelSlaKpi = [];
    this.singleDataSetSlaKpi = [];
    this.chartDataCompleted = [];
    this.chartLabelsCompleted = [];
    this.dropdownItemsOverview= {};
    this.dropdownItemsOrderDetail= {};
    this.dropdownItemsSlaKpis= {};
    this.dropdownItemsCompletedDetail= {};

  }

  setSelectedItemsOverview(req: any){
    this.selectedItemsOverview= req;
  }

  setSelectedItemsOrderDetail(req: any){
    this.selectedItemsOrderDetail= req;
  }

  setSelectedItemsSlaKpis(req: any){
    this.selectedItemsSlaKpis= req;
  }

  setSelectedItemsCompletedDetail(req: any){
    this.selectedItemsCompletedDetail= req;
  }

  setChangedFilterOverview(){
    this.filtersOverviewChangedAlmostOneTime= true;
  }

  setChangedFilterOrderDetail(){
    this.filtersOrderDetailChangedAlmostOneTime= true;
  }

  setChangedFilterSlaKpis(){
    this.filtersSlaKpisChangedAlmostOneTime= true;
  }

  setChangedFilterCompletedDetail(){
    this.fltersCompletedDetailChangedAlmostOneTime= true;
  }

  setInfoOverview(pieChartLabelsOverview: Label[] , pieChartDataOverview: SingleDataSet , ordersOverview: any[]){
    this.pieChartLabelsOverview = pieChartLabelsOverview;
    this.pieChartDataOverview = pieChartDataOverview;
    this.ordersOverview=ordersOverview;
  }

  setInfoListOrdersDetail(listOrderDetail: any[]){
    this.listOrderDetail=listOrderDetail;
  }

  setInfoSlaKpis(listAverageSlaKpi: any[], labelSlaKpi: Label[], singleDataSetSlaKpi: SingleDataSet){
    this.listAverageSlaKpi=listAverageSlaKpi;
    this.labelSlaKpi=labelSlaKpi;
    this.singleDataSetSlaKpi=singleDataSetSlaKpi;
  }

  setInfoCompletedDetail(chartDataCompleted: ChartDataSets[], chartLabelsCompleted: Label[]){
    this.chartDataCompleted=chartDataCompleted;
    this.chartLabelsCompleted=chartLabelsCompleted;
  }

  setOverviewLoaded(){
    this.overviewLoadedAlmostOneTime= true;
  }

  setOrderDetailLoaded(){
    this.orderDetailLoadedAlmostOneTime= true;
  }

  setSlaKpisLoaded(){
    this.slaKpisLoadedAlmostOneTime= true;
  }

  setCompletedDetailLoaded(){
    this.completedDetailLoadedAlmostOneTime= true;
  }

  setDropdownItemsOverview(req: any){
    this.dropdownItemsOverview= req;
  }

  setDropdownItemsOrderDetail(req: any){
    this.dropdownItemsOrderDetail= req;
  }

  setDropdownItemsSlaKpis(req: any){
    this.dropdownItemsSlaKpis= req;
  }

  setDropdownItemsCompletedDetail(req: any){
    this.dropdownItemsCompletedDetail= req;
  }

}
